import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Auth\PhoneVerificationController::edit
* @see app/Http/Controllers/Auth/PhoneVerificationController.php:66
* @route '/auth/phone-verification/edit'
*/
export const edit = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: edit.url(options),
    method: 'post',
})

edit.definition = {
    methods: ["post"],
    url: '/auth/phone-verification/edit',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Auth\PhoneVerificationController::edit
* @see app/Http/Controllers/Auth/PhoneVerificationController.php:66
* @route '/auth/phone-verification/edit'
*/
edit.url = (options?: RouteQueryOptions) => {
    return edit.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Auth\PhoneVerificationController::edit
* @see app/Http/Controllers/Auth/PhoneVerificationController.php:66
* @route '/auth/phone-verification/edit'
*/
edit.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: edit.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Auth\PhoneVerificationController::edit
* @see app/Http/Controllers/Auth/PhoneVerificationController.php:66
* @route '/auth/phone-verification/edit'
*/
const editForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: edit.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Auth\PhoneVerificationController::edit
* @see app/Http/Controllers/Auth/PhoneVerificationController.php:66
* @route '/auth/phone-verification/edit'
*/
editForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: edit.url(options),
    method: 'post',
})

edit.form = editForm

/**
* @see \App\Http\Controllers\Auth\PhoneVerificationController::send
* @see app/Http/Controllers/Auth/PhoneVerificationController.php:100
* @route '/auth/phone-verification/send'
*/
export const send = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: send.url(options),
    method: 'post',
})

send.definition = {
    methods: ["post"],
    url: '/auth/phone-verification/send',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Auth\PhoneVerificationController::send
* @see app/Http/Controllers/Auth/PhoneVerificationController.php:100
* @route '/auth/phone-verification/send'
*/
send.url = (options?: RouteQueryOptions) => {
    return send.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Auth\PhoneVerificationController::send
* @see app/Http/Controllers/Auth/PhoneVerificationController.php:100
* @route '/auth/phone-verification/send'
*/
send.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: send.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Auth\PhoneVerificationController::send
* @see app/Http/Controllers/Auth/PhoneVerificationController.php:100
* @route '/auth/phone-verification/send'
*/
const sendForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: send.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Auth\PhoneVerificationController::send
* @see app/Http/Controllers/Auth/PhoneVerificationController.php:100
* @route '/auth/phone-verification/send'
*/
sendForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: send.url(options),
    method: 'post',
})

send.form = sendForm

/**
* @see \App\Http\Controllers\Auth\PhoneVerificationController::confirm
* @see app/Http/Controllers/Auth/PhoneVerificationController.php:73
* @route '/auth/phone-verification/confirm'
*/
export const confirm = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: confirm.url(options),
    method: 'get',
})

confirm.definition = {
    methods: ["get","head"],
    url: '/auth/phone-verification/confirm',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Auth\PhoneVerificationController::confirm
* @see app/Http/Controllers/Auth/PhoneVerificationController.php:73
* @route '/auth/phone-verification/confirm'
*/
confirm.url = (options?: RouteQueryOptions) => {
    return confirm.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Auth\PhoneVerificationController::confirm
* @see app/Http/Controllers/Auth/PhoneVerificationController.php:73
* @route '/auth/phone-verification/confirm'
*/
confirm.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: confirm.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Auth\PhoneVerificationController::confirm
* @see app/Http/Controllers/Auth/PhoneVerificationController.php:73
* @route '/auth/phone-verification/confirm'
*/
confirm.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: confirm.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Auth\PhoneVerificationController::confirm
* @see app/Http/Controllers/Auth/PhoneVerificationController.php:73
* @route '/auth/phone-verification/confirm'
*/
const confirmForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: confirm.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Auth\PhoneVerificationController::confirm
* @see app/Http/Controllers/Auth/PhoneVerificationController.php:73
* @route '/auth/phone-verification/confirm'
*/
confirmForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: confirm.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Auth\PhoneVerificationController::confirm
* @see app/Http/Controllers/Auth/PhoneVerificationController.php:73
* @route '/auth/phone-verification/confirm'
*/
confirmForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: confirm.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

confirm.form = confirmForm

/**
* @see \App\Http\Controllers\Auth\PhoneVerificationController::verify
* @see app/Http/Controllers/Auth/PhoneVerificationController.php:159
* @route '/auth/phone-verification/confirm'
*/
export const verify = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: verify.url(options),
    method: 'post',
})

verify.definition = {
    methods: ["post"],
    url: '/auth/phone-verification/confirm',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Auth\PhoneVerificationController::verify
* @see app/Http/Controllers/Auth/PhoneVerificationController.php:159
* @route '/auth/phone-verification/confirm'
*/
verify.url = (options?: RouteQueryOptions) => {
    return verify.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Auth\PhoneVerificationController::verify
* @see app/Http/Controllers/Auth/PhoneVerificationController.php:159
* @route '/auth/phone-verification/confirm'
*/
verify.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: verify.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Auth\PhoneVerificationController::verify
* @see app/Http/Controllers/Auth/PhoneVerificationController.php:159
* @route '/auth/phone-verification/confirm'
*/
const verifyForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: verify.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Auth\PhoneVerificationController::verify
* @see app/Http/Controllers/Auth/PhoneVerificationController.php:159
* @route '/auth/phone-verification/confirm'
*/
verifyForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: verify.url(options),
    method: 'post',
})

verify.form = verifyForm

const phoneVerification = {
    edit: Object.assign(edit, edit),
    send: Object.assign(send, send),
    confirm: Object.assign(confirm, confirm),
    verify: Object.assign(verify, verify),
}

export default phoneVerification